// Labels keyed by the stored trigger type.
export const WORKFLOWS_TRIGGERS_TYPE: Record<string, string> = {
  default: 'When AI lacks the knowledge to assist a customer',
  when_asked: 'When asked about',
  when_requested: 'When requested',
  when_interested_in: 'When user is interested in',
  when_referring_to: 'When user refers to',
  when_message_contains: 'When message contains',
  when_message_matches_intent: 'When message matches intent to',
  when_user_mentions: 'When user mentions',
  when_user_sounds: 'When user sounds',
  when_users_tone_is: "When user's tone is",
  when_user_expresses: 'When user expresses',
  when_user_reports: 'When user reports',
};

// Labels keyed by the stored action type.
export const WORKFLOWS_ACTIONS_TYPE: Record<string, string> = {
  clarify: 'Clarify',
  respond: 'Respond',
  ask_for: 'Ask for',
  confirm: 'Confirm',
  apologize_for: 'Apologize for',
  acknowledge: 'Acknowledge',
  use_document: 'Use Document',
  guide_through: 'Guide through',
  offer: 'Offer',
  suggest: 'Suggest',
  escalate: 'Escalate',
  handle_with_crm: 'Escalate immediately',
  forward_to_email: 'Forward to email',
  collect_and_escalate: 'Gather details and escalate',
  close: 'End conversation',
};

export const WORKFLOWS_ACTION_MESSAGES_TYPES = [
  'clarify',
  'respond',
  'ask_for',
  'confirm',
  'use_document',
  'guide_through',
  'suggest',
  'apologize_for',
  'acknowledge',
  'offer',
];
